/**
 * FontAwesome icon for each predefined ("special") tag slug. These are the games
 * defined by the backend EggSpecificTags enum; the icon is the one piece of their
 * presentation that lives frontend-side (the rest -- colour, friendly name -- comes
 * from the API). Custom tags have no entry and render the neutral tag icon.
 *
 * NOTE: the icons listed here must also be present in `icon-whitelist.txt` so the
 * FontAwesome scanner bundles them (they are referenced dynamically, not as literal
 * `<fa :icon="['fas', '...']">` template usages it can detect).
 */
export const EGG_SPECIFIC_TAG_ICONS: Record<string, [string, string]> = {
    srcds: ['fas', 'server'],
    minecraft: ['fas', 'cube'],
    bedrock: ['fas', 'cubes'],
    fivem: ['fas', 'car'],
    rust: ['fas', 'industry'],
    garrysmod: ['fas', 'wrench'],
    hytale: ['fas', 'gem'],
    sbox: ['fas', 'box'],
    palworld: ['fas', 'paw'],
    vrising: ['fas', 'droplet'],
};

export const iconForTagSlug = (slug: string): [string, string] => EGG_SPECIFIC_TAG_ICONS[slug] ?? ['fas', 'tag'];

/**
 * Inline style for a tag chip tinted with its colour: a faint fill, a slightly
 * stronger border, and the colour itself for the text/icon. Returns undefined when
 * the tag has no colour, so callers fall back to their neutral default classes. The
 * hex suffixes are 8-digit-hex alpha applied to the (6-digit) tag colour.
 *
 * When `glow` is set (a special game tag that unlocks features) the chip gets a
 * brighter edge and a soft halo in its own colour, so the whole chip reads as
 * "special" at a glance rather than relying on a tiny, easily-missed icon.
 */
export const tagChipStyle = (color?: string | null, glow = false): Record<string, string> | undefined => {
    if (!color) {
        return undefined;
    }

    const style: Record<string, string> = {
        backgroundColor: `${color}1f`,
        borderColor: glow ? `${color}cc` : `${color}59`,
        color,
    };

    if (glow) {
        // meh looks pretty ugly and distracting, leave for now
        // the icon is good enough of an indicator i think.
        // style.boxShadow = `0 0 5px ${color}99`;
    }

    return style;
};
